/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} As_Buyers_Interact_With_Your_SInputs */

const en_as_buyers_interact_with_your_s = /** @type {(inputs: As_Buyers_Interact_With_Your_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As buyers interact with your storefront, their intent signals will appear here automatically.`)
};

const es_as_buyers_interact_with_your_s = /** @type {(inputs: As_Buyers_Interact_With_Your_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A medida que los compradores interactúen con tu tienda, sus señales de intención aparecerán aquí automáticamente.`)
};

const fr_as_buyers_interact_with_your_s = /** @type {(inputs: As_Buyers_Interact_With_Your_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À mesure que les acheteurs interagissent avec votre vitrine, leurs signaux d'intention s'afficheront automatiquement ici.`)
};

const de_as_buyers_interact_with_your_s = /** @type {(inputs: As_Buyers_Interact_With_Your_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Käufer mit deiner Storefront interagieren, erscheinen ihre Kaufsignale automatisch hier.`)
};

const ja_as_buyers_interact_with_your_s = /** @type {(inputs: As_Buyers_Interact_With_Your_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入者がストアフロントを操作すると、その意図を示すシグナルがここに自動的に表示されます。`)
};

const zh_as_buyers_interact_with_your_s = /** @type {(inputs: As_Buyers_Interact_With_Your_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当买家与您的店铺互动时，他们的意图信号将自动显示在这里。`)
};

const ar_as_buyers_interact_with_your_s = /** @type {(inputs: As_Buyers_Interact_With_Your_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عندما يتفاعل المشترون مع واجهة متجرك، ستظهر إشارات نواياهم هنا تلقائيًا.`)
};

const id_as_buyers_interact_with_your_s = /** @type {(inputs: As_Buyers_Interact_With_Your_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat pembeli berinteraksi dengan etalase Anda, sinyal niat mereka akan muncul di sini secara otomatis.`)
};

const it_as_buyers_interact_with_your_s = /** @type {(inputs: As_Buyers_Interact_With_Your_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Man mano che gli acquirenti interagiscono con la tua vetrina, i loro segnali di intenzione appariranno automaticamente qui.`)
};

const ru_as_buyers_interact_with_your_s = /** @type {(inputs: As_Buyers_Interact_With_Your_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По мере того как покупатели взаимодействуют с вашей витриной, сигналы об их намерениях будут появляться здесь автоматически.`)
};

const pt_as_buyers_interact_with_your_s = /** @type {(inputs: As_Buyers_Interact_With_Your_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conforme os compradores interagem com a sua vitrine, seus sinais de intenção aparecerão aqui automaticamente.`)
};

const ko_as_buyers_interact_with_your_s = /** @type {(inputs: As_Buyers_Interact_With_Your_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매자가 스토어프론트와 상호 작용하면 그들의 의도 시그널이 이곳에 자동으로 나타납니다.`)
};

/**
* | output |
* | --- |
* | "As buyers interact with your storefront, their intent signals will appear here automatically." |
*
* @param {As_Buyers_Interact_With_Your_SInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const as_buyers_interact_with_your_s = /** @type {((inputs?: As_Buyers_Interact_With_Your_SInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<As_Buyers_Interact_With_Your_SInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_as_buyers_interact_with_your_s(inputs)
	if (locale === "es") return es_as_buyers_interact_with_your_s(inputs)
	if (locale === "fr") return fr_as_buyers_interact_with_your_s(inputs)
	if (locale === "de") return de_as_buyers_interact_with_your_s(inputs)
	if (locale === "ja") return ja_as_buyers_interact_with_your_s(inputs)
	if (locale === "zh") return zh_as_buyers_interact_with_your_s(inputs)
	if (locale === "ar") return ar_as_buyers_interact_with_your_s(inputs)
	if (locale === "id") return id_as_buyers_interact_with_your_s(inputs)
	if (locale === "it") return it_as_buyers_interact_with_your_s(inputs)
	if (locale === "ru") return ru_as_buyers_interact_with_your_s(inputs)
	if (locale === "pt") return pt_as_buyers_interact_with_your_s(inputs)
	return ko_as_buyers_interact_with_your_s(inputs)
});